import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import loggingMiddleware from '../redux/middleware/logging/errorCatcher';
import rootReducer from '../redux/reducers';
import * as APIFactory from '../services/APIFactory';
import Pusher from '../services/PusherManager';

const PusherManager = new Pusher(false);

export default function configureStore(initialState) {
  const middleware = [
    loggingMiddleware(),
    thunk.withExtraArgument({ APIFactory, PusherManager }),
  ];

  return createStore(rootReducer, initialState, applyMiddleware(...middleware));
}
